import type { GiftPassSendRow } from '../../api/gift-passes';

import { SEND_STATE_LABEL, formatPassDateTime, sendState } from './gift-passes-model';

export function GiftPassSendItem({ send }: { send: GiftPassSendRow }) {
  const state = sendState(send);
  return (
    <li style={{ padding: '12px 16px', borderBottom: '1px solid var(--nb-border)' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 13, fontWeight: 700, overflowWrap: 'anywhere' }}>
          {send.recipientEmail}
        </span>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-muted)' }}>
          {SEND_STATE_LABEL[state]}
        </span>
      </div>
      <dl className="gp-field-list" style={{ marginTop: 6, fontSize: 12 }}>
        <dt>Scheduled for</dt>
        <dd>{formatPassDateTime(send.scheduledFor)}</dd>
        <dt>Sent</dt>
        <dd>{send.sentAt ? formatPassDateTime(send.sentAt) : '—'}</dd>
        {send.cancelledAt && (
          <>
            <dt>Cancelled</dt>
            <dd>{formatPassDateTime(send.cancelledAt)}</dd>
          </>
        )}
        <dt>Message</dt>
        <dd style={{ whiteSpace: 'pre-wrap', fontStyle: send.message ? 'normal' : 'italic' }}>
          {send.message ?? 'No message'}
        </dd>
      </dl>
    </li>
  );
}
